import { useState } from 'react';
import { STATIC_PAGE_URL_RESELLER } from 'utils/constants';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { useTranslation } from 'react-i18next';
import { JobItem, JobAdjustmentStatusEnum } from 'domains/workspaceDomain';
import { UnderlineText } from 'components/RevxTypography';
import workspaceService from 'services/jobService';
import useLoading from 'hooks/useLoading';
import { useEffect } from 'react';
import { useAppDispatch } from 'app/hooks';
import JobAdjustmentModal from '../../components/JobAdjustmentModal';

const { AWAITING_APPROVAL, AWAITING_ACCEPT, NONE, DECLINED, ACCEPTED } =
  JobAdjustmentStatusEnum;

type Props = {
  data: JobItem;
  onModalSuccess?: () => void;
};

const CardActionUploadInvoiceTips = ({ data, onModalSuccess }: Props) => {
  const { t } = useTranslation();
  const {
    app: { showLoading, hideLoading },
  } = useAppDispatch();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [jumpJobAdjust, jumpJobAdjustLoading] = useLoading(() => {
    return jobAdjustmentHandler();
  });
  const showViewJobAdjustment = [AWAITING_ACCEPT, AWAITING_APPROVAL].includes(
    data.adjustmentStatus
  );

  useEffect(() => {
    jumpJobAdjustLoading ? showLoading() : hideLoading();
  }, [jumpJobAdjustLoading, showLoading, hideLoading]);

  const jobAdjustmentHandler = async () => {
    // 只有在没有活跃的 adjustment 时才创建新的
    if ([NONE, DECLINED, ACCEPTED].includes(data.adjustmentStatus)) {
      await workspaceService.jobAdjustments(data.id);
    }
    setModalVisible(true);
  };

  const handleModalSuccess = async () => {
    console.log('Modal success handler called');
    try {
      if (onModalSuccess) {
        console.log('Calling onModalSuccess callback');
        await onModalSuccess();
        console.log('onModalSuccess callback completed successfully');
      }
    } catch (error) {
      console.error('Error in modal success handler:', error);
    } finally {
      console.log('Modal success handler finished');
    }
  };

  return (
    <RevxFlexLayout>
      {!showViewJobAdjustment && (
        <RevxFlexLayout className="mt-10" wrap="wrap">
          <RevxFlexLayout wrap="wrap" justify="justify-center">
            <RevxFlexLayout style={{ textAlign: 'center' }}>
              If your invoice total is not the same as the total displayed here,
              please submit a
            </RevxFlexLayout>
            <RevxFlexLayout>
              <UnderlineText size="small" color="blue" onClick={jumpJobAdjust}>
                Job Adjustment
              </UnderlineText>
            </RevxFlexLayout>
          </RevxFlexLayout>
          <RevxFlexLayout
            justify="justify-center"
            style={{ width: '100%' }}
            className="mt-10"
          >
            <a
              href={STATIC_PAGE_URL_RESELLER}
              target="_blank"
              style={{ textDecoration: 'underline' }}
              rel="noreferrer"
            >
              {t('workspace.list.resaleCertificate')}
            </a>
          </RevxFlexLayout>
        </RevxFlexLayout>
      )}
      <JobAdjustmentModal
        visible={modalVisible}
        jobId={data.id}
        onCancel={() => setModalVisible(false)}
        onSuccess={handleModalSuccess}
      />
    </RevxFlexLayout>
  );
};

export default CardActionUploadInvoiceTips;
